// src/components/shared/tables/sortableTable.tsx
import { type Column, type SortConfig } from './types';
import { Table } from './table';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from "@/lib/utils";

interface SortableColumn<T> extends Omit<Column<T>, 'header'> {
    header: string;
}

interface SortableTableProps<T> {
    data: T[];
    columns: SortableColumn<T>[];
    sortConfig?: SortConfig;
    onSort?: (key: string) => void;
    className?: string;
}

export function SortableTable<T>({
                                     data,
                                     columns,
                                     sortConfig,
                                     onSort,
                                     className
                                 }: SortableTableProps<T>) {
    const sortableColumns: Column<T>[] = columns.map(({ header, ...column }) => ({
        ...column,
        header: (
            <Button
                variant="ghost"
                className={cn(
                    "p-0 font-medium hover:bg-transparent",
                    !column.sortable && "cursor-default"
                )}
                onClick={() => column.sortable && onSort?.(column.key)}
            >
                <span>{header}</span>
                {column.sortable && sortConfig?.key === column.key && (
                    sortConfig?.direction === 'asc' ?
                        <ChevronUp className="ml-2 h-4 w-4" /> :
                        <ChevronDown className="ml-2 h-4 w-4" />
                )}
            </Button>
        )
    }));

    return <Table data={data} columns={sortableColumns} className={className} />;
}
